import { render, staticRenderFns } from "./BotChatList.vue?vue&type=template&id=19fba7ef"
import script from "./BotChatList.vue?vue&type=script&lang=js"
export * from "./BotChatList.vue?vue&type=script&lang=js"
import style0 from "./BotChatList.vue?vue&type=style&index=0&id=19fba7ef&prod&lang=scss"
import style1 from "./BotChatList.vue?vue&type=style&index=1&id=19fba7ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports